import { QueryParams } from '../../api/models';
import { Expose } from 'class-transformer';

export class UserQueryParams extends QueryParams {
  @Expose({ name: 'role_id' })
  public roleId?: number;
}
